import { Employee } from './Employee.interface'
import { UserAuthority } from './UserAuthority.interface'

const find = require('lodash/find')

export interface User extends AssumingRoleFromUser {
  id: number
  username: string
  enabled: boolean
  profileImageUrl: string
  authorities: UserAuthority[]
  locations: Location[]
  employee: Employee
}

interface AssumingRoleFromUser {
  assumingRoleFrom?: User
}

export function hasPermission(user: User, permission: string): boolean {  
  return hasAnyPermission(user, [permission])
}

export function hasAnyPermission(user: User, permissions: string[]): boolean {
  permissions.push('ROLE_ADMIN') // Add ROLE_ADMIN so it doesn't have to be listed on every item

  let authorities = user.authorities

  const assumingRoleFromUser = user.assumingRoleFrom
  if (assumingRoleFromUser && assumingRoleFromUser.authorities) {
    authorities = assumingRoleFromUser.authorities
  }

  const authoritiesFound = find(authorities, authority => permissions.indexOf(authority.authority) > -1)
  return authoritiesFound !== undefined  
}



// WEBPACK FOOTER //
// ./src/lib/interfaces/User.interface.ts